export default "__VITE_ASSET__DNzSE52N__"